import { useMemo } from "react";
import { Stack, Text } from "@fluentui/react";
import type { TurnCitation } from "../chatTurn";
import styles from "../Answer/Answer.module.css";

interface UICitation {
  index: number;
  text: string;
  url: string;
  citationText?: string;
}

const build = (citation: TurnCitation): UICitation => {
  return {
    index: citation.index,
    text: citation.title,
    url: citation.url,
    citationText: citation.snippet || citation.title
  };
};

interface CitationsProps {
  citations?: TurnCitation[];
  isStreaming: boolean;
  onCitationClicked: (filePath: string, citationText?: string) => void;
}

export const Citations = ({ citations, isStreaming, onCitationClicked }: CitationsProps) => {
  const uiCitations = useMemo(() => {
    if (!citations || citations.length === 0) return [];
    return citations.map(build);
  }, [citations]);

  if (isStreaming || uiCitations.length === 0) return null;

  return (
    <Stack.Item>
      <Stack tokens={{ childrenGap: 4 }} style={{ marginLeft: "36px" }}>
        <Text variant="medium" className={styles.citationHeader} styles={{ root: { fontWeight: 700 } }}>
          Source:
        </Text>
        <Stack horizontal wrap tokens={{ childrenGap: 5 }}>
          {uiCitations.map(citation => (
            <a
              id={`citation-${citation.index}`}
              key={`${citation.index}-${citation.url}`}
              className={styles.citation}
              onClick={e => {
                e.preventDefault();
                if (citation.url) {
                  onCitationClicked(citation.url, citation.citationText);
                }
              }}
            >
              {`${citation.index}. ${citation.text}`}
            </a>
          ))}
        </Stack>
      </Stack>
    </Stack.Item>
  );
};
